// @vue/component
export default {
  name: "PuxEmpty",
};
